import { createContext } from 'react';
import { TableContextValue } from 'src/components/DataTable/types/DataTable';

export const DataTableContext = createContext<TableContextValue<
  unknown,
  unknown
> | null>(null);
